import {storable} from "./storable.ts";
import {type Readable, readable, writable, Writable} from "svelte/store";
import {Registration} from "@shared/Types.ts";

export const page = storable<'Admin' | 'EnterCode' | 'EnterEmail' | 'Registration'>('wob.page', 'EnterEmail')
export const currentTime: Readable<number> = readable(Date.now(), (set) => {
    setInterval(() => set(Date.now()), 200)
})

export const email = storable<string>('wob.email', '');

// page.set('EnterEmail')

export const origin = window.location.origin.replace('5173', '3000');

export async function fetchOrigin(path:  string, init?: RequestInit | boolean){
    if (typeof init === 'boolean') {
        init = {};
    }
    console.log('origin', origin, path)
    return fetch(new URL(path, origin).toString(), {credentials: 'same-origin', ...init});
}

export const registration: Writable<Registration> = writable({} as Registration);
registration.subscribe(console.log)